import { useApi } from '@/shared/api/http';
import type {
  IGetPublicationsParams,
  IPublicationPayload,
} from '@/entities/publication/model/types/publication';

export const usePublicationService = () => {
  const api = useApi();

  const getPublications = async (params: IGetPublicationsParams) => {
    return await api.get('out-post/', { params: { ...params } });
  };

  const createPublication = async (dataReq: IPublicationPayload) => {
    return await api.post('out-post', dataReq);
  };

  const updatePublication = async (
    publicationId: number,
    dataReq: IPublicationPayload,
  ) => {
    return await api.patch(`out-post/${publicationId}`, dataReq);
  };

  const deletePublication = async (publicationId: number) => {
    return await api.delete(`out-post/${publicationId}`);
  };

  return {
    getPublications,
    createPublication,
    updatePublication,
    deletePublication,
  };
};
